<template>
    <div class="layout-topbar">
        <div class="topbar-left">
            <a tabindex="0" class="menu-button" @click="onMenuButtonClick">
                <i class="pi pi-times"></i>
            </a>
            
            

            <router-link to="/" class="horizontal-logo">
                <img id="logo-horizontal" src="/layout/images/logo-white.png" alt="diamond-layout" style="padding: 5px 0rem; height: 5rem;"/>
            </router-link>

            <span class="topbar-separator"></span>

            <Button v-show="navigationHistory.length > 0" :label="$t('btn.back')" icon="pi pi-arrow-left" class="m-2 p-button-outlined p-button-sm" @click="$router.back()" />
            <div class="layout-breadcrumb viewname" style="text-transform: uppercase">
                    <span>{{$store.state.security.navbarTitle ? $t($store.state.security.navbarTitle): ''}}</span>
            </div>

            <!-- <img id="logo-mobile" class="mobile-logo" src="/layout/images/logo-only-dark.png" alt="diamond-layout" /> -->
        </div>

        <AppMenu :model="menu" :layoutMode="layoutMode" :active="menuActive" :mobileMenuActive="staticMenuMobileActive"
            @menu-click="onMenuClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu>

        <div class="layout-mask modal-in"></div>

        <div class="topbar-right">
            <ul class="topbar-menu">
                <Tag :severity="envName == 'PRODUCTION' ? 'danger' : ''" :value="envName == 'PRODUCTION' ? 'PRODUCTION' : 'TEST'"></Tag>
                <li class="notifications-item" :class="{ 'active-menuitem ': topbarNotificationMenuActive }">
                    <a href="#" tabindex="0" @click="onTopbarNotificationMenuButtonClick">
                        <i class="pi pi-bell"></i>
                        <span class="topbar-badge">{{$store.state.notifications.notifications.length}}</span>
                    </a>
                    <ul class="notifications-menu fade-in-up">
                        <li role="menuitem" @click="goToNotification">
                            <a tabindex="0">
                                <i class="pi pi-send"></i>
                                <div class="notification-item">
                                    <div class="notification-summary">Send</div>
                                    <div class="notification-detail">Send new notification</div>
                                </div>
                            </a>
                        </li>
                        <li role="menuitem" @click="goToThreads">
                            <a tabindex="0">
                                <i class="pi pi-align-justify"></i>
                                <div class="notification-item">
                                    <div class="notification-summary">Threads</div>
                                    <div class="notification-detail">Show your threads</div>
                                </div>
                            </a>
                        </li>
                        <li v-for="notification in $store.state.notifications.notifications" :key="notification.id">
                            <a tabindex="0">
                                <i class="pi pi-comments" style="color: #2196f3"></i>
                                <div class="notification-item" @click="showNotification(notification.id)">
                                    <div class="notification-summary">From: {{notification.sender}}</div>
                                    <div class="notification-detail">Object: {{notification.notificationObject}}</div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="notifications-item" v-if="isRootPath">
                    <a tabindex="0" @click="addFavourite" v-if="!isCurrentRouteAFavourite">
                        <i class="pi pi-star" style="color: #2196f3"></i>
                    </a>
                    <a tabindex="0" @click="removeFavourite" v-if="isCurrentRouteAFavourite">
                        <i class="pi pi-star-fill" style="color: #2196f3"></i>
                    </a>
                </li>

                <li class="right-sidebar-item" v-if="navigationHistory.length > 0">
                    <a href="#" tabindex="0" @click="onRightMenuClick">
                        <i class="pi pi pi-history" style="color: #2196f3"></i>
                    </a>
                </li>

                <li class="profile-item" :class="{ 'active-menuitem fadeInDown': topbarUserMenuActive }">
                    <a href="#" @click="onTopbarUserMenuButtonClick">
                        <img src="/img/avatar.png" alt="diamond-layout" class="profile-image" />
                        <span class="profile-name">{{`${this.$store.state.security.user.firstName} ${this.$store.state.security.user.lastName}` }}</span>
                    </a>

                    <ul class="profile-menu fade-in-up">
                        <!-- <li class="m-2">
                            <SelectButton v-model="selectedLanguage" :options="languages" optionLabel="name" optionValue="code" @change="setLanguage">
                                <template #option="slotProps">
                                    <div>
                                        <img :src="slotProps.option.src" :class="slotProps.option.cls" width="30" data-v-2b22f11f="">
                                    </div>
                                </template>
                            </SelectButton>
                            </li> -->
                        <li @click="logout">
                            <a>
                                <i class="pi pi-power-off"></i>
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </li>

            </ul>
        </div>
    </div>

    <Dialog position="top" v-model:visible="displayNotificationPopup">
        <h3>{{displayNotificationPopupText.notificationObject}}</h3>
        <h5>From: {{displayNotificationPopupText.from}}</h5>
        <h5>Date: {{displayNotificationPopupText.date}}</h5>
        <div v-html="displayNotificationPopupText.text"></div>
    </Dialog>

</template>

<script>

const env = process.env.NODE_ENV;
import NotificationService from './services/notifications';
import ConfigurationService from './services/configuration';
import AppMenu from "./AppMenu";
import Dialog from 'primevue/dialog';
// import SelectButton from 'primevue/selectbutton';
import Button from 'primevue/button';

// import CloudMessaging from './common/cloud-messaging';
// import { getMessaging, onMessage, getToken } from "firebase/messaging";
// const vapidKey = 'BImPM7ew-Dt0lCw5Zh2inHOIAPTDxWQquD_Xoz82qPhaIaVDwFDSrQuSGoW8E1TVKbzdMA_mXJPOdmypbuXDtH0';

export default {
    name: "AppTopbar",
    emits: ["menu-click", "menuitem-click", "root-menuitem-click", "menu-button-click", "search-click", "topbar-notification", "topbar-user-menu", "right-menubutton-click", "right-menu-click"],
    props: {
        topbarNotificationMenuActive: Boolean,
        topbarUserMenuActive: Boolean,
        layoutMode: String,
        menu: Array,
        menuActive: Boolean,
        staticMenuMobileActive: Boolean
    },
    data() {
        return {
            items: [],
            preferencesCreated: false,
            baseConfig: {},
            displayNotificationPopup: false,
            displayNotificationPopupText: {},
            selectedLanguage: this.$store.state.security.language,
            languages: [
                {name: 'English', code: 'en', cls: 'flag flag-uk', src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeAQMAAABt+G7kAAAAA1BMVEVMaXFNx9g6AAAAAXRSTlMAQObYZgAAAAtJREFUeF5jGHYAAADSAAEzF5gpAAAAAElFTkSuQmCC'},
                {name: 'Italiano', code: 'it',cls: 'flag flag-it',  src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeAQMAAABt+G7kAAAAA1BMVEVMaXFNx9g6AAAAAXRSTlMAQObYZgAAAAtJREFUeF5jGHYAAADSAAEzF5gpAAAAAElFTkSuQmCC'}
            ],
        };
    },
    components: {
        AppMenu,
        Dialog,
        // SelectButton,
        Button
    },
    created(){
        // getToken(CloudMessaging, {vapidKey: vapidKey}).then(e => console.log(e));
        // onMessage(CloudMessaging, (payload) => {
        //     console.log('Message received. ', payload);
        //     this.$store.dispatch("notifications/addNotification", payload);

        // });
        // const channel = new window.BroadcastChannel("sw-messages");
        // channel.addEventListener('message', (event)=> {
        //     console.log('backgroundChannel', event.data)
        //     this.$store.dispatch("notifications/addNotification", event.data);
        // })
    },
    mounted() {
        NotificationService.getNotifications(response => {
            if(response.success){
                this.$store.dispatch("notifications/setNotifications", response.data);
            }
        });
        let userId = this.$store.getters['security/userId'];
        this.baseConfig = {
            name: 'UserPreference - ' + userId,
            type: 'UserPreference',
            description: 'UserPreference - ' + userId,
            value: {
                userId: userId,
                favourites: []
            }
        }
        this.loadFavourites();


        
    },
    unmounted() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    },
    computed: {
        isRootPath() {
            return this.$route.name != 'home';
        },
        userPreferences(){
            return this.$store.state.security.userPreferences;
        },
        isCurrentRouteAFavourite(){
            let h = this.$route.href;
            let found = this.userPreferences.filter(i => h && i.href == h.replace('#',''));
            return found && found.length >0;
        },
        navigationHistory(){
            let data = [];
            let history = this.$store.state.security.navigationHistory;

            for(let i=0; i<history.length; i++){
                data.push({
                    label: this.$t(history[i].title),
                    to: history[i].href
                })
            }

            return data;
        },
        envName(){
            return env ? env.toUpperCase() : '';
            //return process.env.ENVIRONMENT_NAME;
        }
    },
    methods: {
        onMenuClick(event) {
            this.$emit("menu-click", event);
        },
        onMenuItemClick(event) {
            this.$emit("menuitem-click", event);
        },
        onRootMenuItemClick(event) {
            this.$emit("root-menuitem-click", event);
        },
        onMenuButtonClick(event) {
            this.$emit("menu-button-click", event);
        },
        onSearchClick(event) {
            this.$emit("search-click", event);
        },
        onTopbarNotificationMenuButtonClick(event) {
            this.$emit("topbar-notification", event);
        },
        onTopbarUserMenuButtonClick(event) {
            this.$emit("topbar-user-menu", event);
        },
        onRightMenuClick(event) {
            this.$emit("right-menubutton-click", event);
        },
        isMobile() {
            return window.innerWidth <= 1091;
        },
        goToNotification() {
           this.$router.push('/notifications');
        },
        goToThreads() {
           this.$router.push('/threads');
        },
        logout(){
            this.$store.dispatch("security/setUser", null);
            this.$store.dispatch("security/setMenu", []);
            location.reload();
        },
        loadFavourites: function(){
            let userId = this.$store.getters['security/userId'];
            let data = {
                q: JSON.stringify({
                    type: "UserPreference",
                    "value.userId": userId
                })
            }
            ConfigurationService.get(data, response => {
                if(response.success && response.data.data && response.data.data.length > 0){
                    this.baseConfig = response.data.data[0];
                    this.$store.dispatch("security/setUserPreferences", response.data.data[0].value.favourites);
                    this.preferencesCreated = true;
                }
            })
        },
        addFavourite: function(){
            if(this.$route.name !== 'home'){
                this.baseConfig.value.favourites.push({
                    href: this.$route.href.replace('#',''),
                    title: this.$store.state.security.navbarTitle
                });

                if(this.preferencesCreated){
                    ConfigurationService.update(this.baseConfig, () => {
                        this.loadFavourites()
                    })
                }else{
                    ConfigurationService.insert(this.baseConfig, () => {
                        this.loadFavourites()
                    })
                }
            }

        },
        removeFavourite: function(){
            let h = this.$route.href.replace('#','');
            this.baseConfig.value.favourites = this.baseConfig.value.favourites.filter(function(value){
                return value.href != h;
            });
            ConfigurationService.update(this.baseConfig, () => {
                this.loadFavourites()
            })
        },
        showNotification(notificationId) {
            const notification = this.$store.state.notifications.notifications
                .filter(el => el.id == notificationId)[0];
            this.displayNotificationPopup = true;
            this.displayNotificationPopupText = {
                notificationObject: notification.notificationObject,
                from: notification.sender,
                date: notification.notificationDate,
                text: notification.notificationText
            };
            console.log(notification);
        },
        setLanguage(e){
            this.$store.dispatch("security/setLanguage", e.value);
            this.$root.$i18n.changeLocale(this.$store.state.security.language);
        },
    }
};
</script>

<style>

@media screen and (max-width: 1091px){
    .layout-wrapper .layout-topbar .topbar-menu {
        justify-content: end;
    }

    .notifications-item{
        margin-right: 10px;
    }
}
</style>